export const colors = {
    // BRAND
    'brand-1000': '#5D3471',
    'brand-900': '#2C0A3D',
    'brand-800': '#371847',
    'brand-700': '#642682',
    'brand-600': '#3E1856',
    'brand-500': '#4F2265',
    'brand-450': '#5D3471',
    'brand-400': '#8D51A2',
    'brand-300': '#A791B2',
    'brand-200': '#E7B0EF',
    'brand-100': '#EDE9F0',
    'brand-0': '#F5F2F6',
    // BRAND COMPLIMENT
    'brand-compliment-600': '#3D92C4',
    'brand-compliment-500': '#44A2DA',
    'brand-compliment-300': '#A2D1ED',
    'brand-compliment-200': '#D2E9F6',
    'brand-compliment-100': '#ECF6FB',
    // TEXT COLORS
    'text-primary': '#312039',
    'text-secondary': '#766A7B',
    'text-subtle': '#BAB5BD',
    'text-basic': '#FFFFFF',
    // BASIC COLORS
    'basic-transparent-100': 'rgba(255,255,255,0.08)',
    'basic-transparent-200': 'rgba(255,255,255,0.16)',
    'basic-transparent-300': 'rgba(255,255,255,0.24)',
    'basic-transparent-400': 'rgba(255,255,255,0.32)',
    'dark-1000': '#000000',
    'dark-600': '#181515',
    'dark-500': '#1D1D1D',
    'dark-400': '#303030',
    'dark-300': '#454545',
    'dark-200': '#414141',
    'dark-100': '#676767',
    'dark-transparent-100': 'rgba(29, 29, 29, 0.08)',
    'dark-transparent-200': 'rgba(29, 29, 29, 0.16)',
    'dark-transparent-300': 'rgba(29, 29, 29, 0.24)',
    'dark-transparent-400': 'rgba(29, 29, 29, 0.32)',
    'dark-transparent-500': 'rgba(29, 29, 29, 0.4)',
    'dark-transparent-600': 'rgba(29, 29, 29, 0.48)',
    'dark-transparent-700': 'rgba(0, 0, 0, 0.4)',
    'dark-transparent-1000': 'rgba(0, 0, 0, 0.6)',
    // PRIMARY (BRAND)
    // Some of these are repeated (consider conslidating)
    'primary-100': '#DAF8FD',
    'primary-200': '#B6EEFB',
    'primary-300': '#8FDAF3',
    'primary-400': '#70C3E8',
    'primary-500': '#44A2DA',
    'primary-600': '#317FBB',
    'primary-700': '#22609C',
    'primary-800': '#15447E',
    'primary-900': '#0D3068',
    'primary-transparent-100': 'rgba(68, 162, 218, 0.08)',
    'primary-transparent-200': 'rgba(68, 162, 218, 0.16)',
    'primary-transparent-300': 'rgba(68, 162, 218, 0.24)',
    'primary-transparent-400': 'rgba(68, 162, 218, 0.32)',
    'primary-transparent-500': 'rgba(68, 162, 218, 0.4)',
    'primary-transparent-600': 'rgba(68, 162, 218, 0.48)',
    // GRAY
    'gray-10': 'rgba(248, 248, 248, 1)',
    'gray-80': 'rgba(235, 235, 235, 1)',
    'gray-100': 'rgba(219, 219, 219, 1)',
    // SUCCESS
    'success-100': '#D7FCE0',
    'success-200': '#B0F9CA',
    'success-300': '#85EEB5',
    'success-400': '#63DEA7',
    'success-500': '#30AD7F',
    'success-600': '#26AC8A',
    'success-700': '#1A907E',
    'success-800': '#10746E',
    'success-900': '#0A5B60',
    'success-transparent-100': 'rgba(48, 173, 127, 0.08)',
    'success-transparent-200': 'rgba(48, 173, 127, 0.16)',
    'success-transparent-300': 'rgba(48, 173, 127, 0.24)',
    'success-transparent-400': 'rgba(48, 173, 127, 0.32)',
    'success-transparent-500': 'rgba(48, 173, 127, 0.4)',
    'success-transparent-600': 'rgba(48, 173, 127, 0.48)',
    // INFO
    'info-100': '#CCF5FF',
    'info-200': '#99E6FF',
    'info-300': '#66D0FF',
    'info-400': '#3FBAFF',
    'info-500': '#0095FF',
    'info-600': '#0073DB',
    'info-700': '#0056B7',
    'info-800': '#003C93',
    'info-900': '#002B7A',
    'info-transparent-100': 'rgba(0, 149, 255, 0.08)',
    'info-transparent-200': 'rgba(0, 149, 255, 0.16)',
    'info-transparent-300': 'rgba(0, 149, 255, 0.24)',
    'info-transparent-400': 'rgba(0, 149, 255, 0.32)',
    'info-transparent-500': 'rgba(0, 149, 255, 0.4)',
    'info-transparent-600': 'rgba(0, 149, 255, 0.48)',
    // WARNING
    'warning-100': '#FFF4CC',
    'warning-200': '#FFE799',
    'warning-300': '#FFD666',
    'warning-400': '#FFC53F',
    'warning-500': '#FFAA00',
    'warning-600': '#DB8A00',
    'warning-700': '#B76D00',
    'warning-800': '#935300',
    'warning-900': '#7A4000',
    'warning-transparent-100': 'rgba(255, 170, 0, 0.08)',
    'warning-transparent-200': 'rgba(255, 170, 0, 0.16)',
    'warning-transparent-300': 'rgba(255, 170, 0, 0.24)',
    'warning-transparent-400': 'rgba(255, 170, 0, 0.32)',
    'warning-transparent-500': 'rgba(255, 170, 0, 0.4)',
    'warning-transparent-600': 'rgba(255, 170, 0, 0.48)',
    // DANGER
    'danger-100': '#FCE4D6',
    'danger-200': '#F9C4AD',
    'danger-300': '#EF9982',
    'danger-400': '#DF7060',
    'danger-500': '#CB3831',
    'danger-600': '#AE2329',
    'danger-700': '#921827',
    'danger-800': '#750F24',
    'danger-900': '#610923',
    'danger-transparent-100': 'rgba(203, 56, 49, 0.08)',
    'danger-transparent-200': 'rgba(203, 56, 49, 0.16)',
    'danger-transparent-300': 'rgba(203, 56, 49, 0.24)',
    'danger-transparent-400': 'rgba(203, 56, 49, 0.32)',
    'danger-transparent-500': 'rgba(203, 56, 49, 0.4)',
    'danger-transparent-600': 'rgba(203, 56, 49, 0.48)',
    // NEUTRAL (Interpretation)
    'neutral-100': '#F3DFF5',
    'neutral-200': '#E6C1EB',
    'neutral-300': '#B990C3',
    'neutral-400': '#766A7B',
    'neutral-500': '#312039',
    'neutral-600': '#7C5B88',
    'neutral-700': '#1D1029',
    'neutral-800': '#150A21',
    'neutral-900': '#0F061B',
    // SUBTLE (Interpretation)
    'subtle-100': '#FBF9FB',
    'subtle-200': '#F7F4F8',
    'subtle-300': '#E9E5EB',
    'subtle-400': '#D5D0D7',
    'subtle-500': '#BAB5BD',
    'subtle-600': '#9584A2',
    'subtle-700': '#715B88',
    'subtle-800': '#50396D',
    'subtle-900': '#38225A',
    // FLAT aka GREY (Interpretation)
    'flat-100': '#FCFCFC',
    'flat-200': '#F8F8F8',
    'flat-300': '#EBEBEB',
    'flat-400': '#DBDBDB',
    'flat-500': '#929292',
    'flat-600': '#929292',
    'flat-700': '#6D6D6D',
    'flat-800': '#494949',
    'flat-900': '#3A3A3A',
    'flat-1000': '#2C2C2C',
    'flat-1100': '#1D1D1D',
    'flat-1200': '#0F0F0F',
};
// Prefix `color-`
export default Object
    .entries(colors)
    .reduce((acc, [key, val]) => ({ ...acc, [`color-${key}`]: val }), {});
//# sourceMappingURL=colors.js.map